<div class="d-flex flex-column h-100 gap-6">
  @if (dataType() !== 'vehicle') {
    <div class="w-100 d-flex justify-content-between align-items-end">
      <si-form-item label="Workspace" class="w-50 mb-0">
        <select
          aria-label="number"
          class="form-select"
          [(ngModel)]="selectedWorkspaceId"
          (ngModelChange)="onSelectedWorkspaceChange()"
        >
          <option [ngValue]="undefined">{{ 'SHARED.ALL' | translate }}</option>
          @for (workspace of availableWorkspaces(); track $index) {
            <option [ngValue]="workspace.id">
              {{ workspace.name }}
            </option>
          }
        </select>
      </si-form-item>
      <div
        [siTooltip]="
          selectedWorkspace()
            ? ''
            : ('LOAD_MODAL.TOOLTIP_EDIT_MODE'
              | translate
                : {
                    type:
                      (`${(this.dataType() | uppercase)}.${(this.dataType() | uppercase)}S`
                      | translate)
                  })
        "
      >
        <button
          type="button"
          class="btn btn-secondary"
          aria-label="badge"
          [disabled]="!selectedWorkspace()"
          (click)="toggleViewMode()"
          >{{
            viewMode() === 'load'
              ? ('LOAD_MODAL.ENTER_EDIT_MODE' | translate)
              : ('LOAD_MODAL.EXIT_EDIT_MODE' | translate)
          }}</button
        >
      </div>
    </div>
  }

  <div class="w-100 d-flex align-items-center gap-5">
    <si-search-bar
      class="w-50"
      placeholder="Search"
      colorVariant="base-0"
      prohibitedCharacters="*?"
      [debounceTime]="400"
      [showIcon]="true"
      [(ngModel)]="searchBarInput"
    />

    @if (dataType() !== 'vehicle') {
      <si-form-item
        class="m-0"
        [label]="
          'LOAD_MODAL.SHOW_DELETED_ITEMS'
            | translate
              : {
                  type:
                    (`${(this.dataType() | uppercase)}.${(this.dataType() | uppercase)}S`
                    | translate)
                }
        "
      >
        <input type="checkbox" class="form-check-input" [(ngModel)]="showRemovedItems" />
      </si-form-item>
    }
  </div>

  <!-- Dont show tag options in public workspace -->
  @if (selectedWorkspace(); as workspace) {
    @if (workspace.name !== 'Public') {
      <div class="w-100 d-flex gap-3">
        <button type="button" class="btn btn-primary" [cdkMenuTriggerFor]="tagsContextMenu">
          {{ 'SHARED.TAGS' | translate }}
        </button>
        <si-filter-bar
          colorVariant="base-0"
          class="w-100 p-0"
          [allowReset]="false"
          [(filters)]="visibleTagBadges"
        />
      </div>
    }
  }

  <div class="w-100 flex-grow-1">
    <si-tree-view
      class="h-100"
      [enableCheckbox]="showCheckboxes()"
      [enableIcon]="false"
      [enableSelection]="enableSelection()"
      [items]="filteredTreeItems()"
      [singleSelectMode]="true"
      [selectedItem]="selectedTreeItem()"
      [expandOnClick]="true"
      [expandCollapseAll]="true"
      (treeItemClicked)="this.selectedTreeItem.set($event)"
      (dblclick)="viewMode() === 'load' ? onOpenItemClick() : null"
      (treeItemCheckboxClicked)="updateCheckedElements()"
    >
      <ng-template let-item siTreeViewItemTemplate="workspace">
        <div>
          <p class="m-0">{{ item.customData.workspace.name }}</p>
        </div>
      </ng-template>

      <ng-template let-item siTreeViewItemTemplate="group">
        <div>
          <p class="m-0">{{ item.customData.name }}</p>
        </div>
      </ng-template>

      <ng-template let-item siTreeViewItemTemplate="variant" class="w-100">
        <div class="d-flex align-items-center w-100 justify-content-between">
          <!-- Left -->
          <div class="d-flex flex-column w-100 gap-3 py-4">
            <!-- Top -->
            <div class="d-flex gap-4 w-100 align-items-center">
              <p class="m-0" [class.text-muted]="item.customData.variant.deleted">{{
                item.customData.variant.version
              }}</p>
              <div class="d-flex w-100 gap-2 align-items-center">
                @for (tag of item.customData.variant.tags; track $index) {
                  <span class="badge bg-info m-0">{{ tag.name }}</span>
                }
              </div>
            </div>
            <!-- Bottom -->
            @if (item.customData.variant.description.length > 0) {
              <div class="d-flex align-items-center w-100">
                <div class="w-100 text-truncate">
                  <p
                    class="text-secondary m-0 text-wrap"
                    [class.text-muted]="item.customData.variant.deleted"
                  >
                    {{ item.customData.variant.description }}
                  </p>
                </div>
              </div>
            }
          </div>
          <!-- Right -->
          <div>
            <p class="text-secondary m-0" [class.text-muted]="item.customData.variant.deleted">
              {{
                item.customData.variant.creationDate
                  | date: (translateService.currentLang === 'de' ? 'dd.MM.yyyy' : 'MM/dd/yyyy')
              }}
            </p>
          </div>
        </div>
      </ng-template>

      <ng-template let-item siTreeViewItemTemplate="vehicle" class="w-100">
        <div class="d-flex align-items-center w-100 justify-content-between">
          <div class="d-flex flex-column w-100">
            <div class="d-flex gap-4 w-100 align-items-center">
              <p class="m-0">{{ item.customData.name }}</p>
              <div class="d-flex w-100 gap-2 align-items-center">
                @for (tag of item.customData.vehicle.tags; track $index) {
                  <span class="badge bg-info m-0">{{ tag.name }}</span>
                }
              </div>
            </div>
            @if (item.customData.type) {
              <small class="text-secondary">{{ item.customData.type }}</small>
            }
          </div>
        </div>
      </ng-template>
    </si-tree-view>
  </div>

  <div class="mt-3 w-100 gap-5 d-flex justify-content-end">
    @if (viewMode() === 'load') {
      <button
        type="button"
        class="btn btn-secondary mt-auto w-25"
        [disabled]="selectedTreeItemType() !== 'variant' && selectedTreeItemType() !== 'vehicle'"
        (click)="onOpenItemClick()"
      >
        <i class="icon element-download"></i>
        {{ 'SHARED.LOAD' | translate }}
      </button>
    } @else {
      @if (selectedWorkspace(); as workspace) {
        @if (workspace.name !== 'Public') {
          <div class="d-flex gap-3 align-items-center">
            <button
              type="button"
              class="btn btn-secondary mt-auto w-100 h-100"
              (click)="updateCheckedElements(); openModal(removeTagsFromItemsModalTemplate)"
            >
              <i class="icon element-minus"></i
              >{{ 'SHARED.REMOVE_ITEM' | translate: { type: ('SHARED.TAGS' | translate) } }}
            </button>
            <button
              type="button"
              class="btn btn-secondary mt-auto w-100 h-100"
              (click)="updateCheckedElements(); openModal(addTagsToItemsModalTemplate)"
            >
              <i class="icon element-plus"></i
              >{{ 'SHARED.ADD' | translate: { type: ('SHARED.TAGS' | translate) } }}
            </button>
          </div>
        }
      }
      <div class="d-flex gap-3 align-items-center">
        <button
          type="button"
          class="btn btn-secondary mt-auto w-100 h-100"
          (click)="updateCheckedElements(); showRemoveItemsFromWorkspaceDialog()"
        >
          <i class="icon element-minus"></i
          >{{ 'LOAD_MODAL.REMOVE_FROM_WORKSPACE' | translate: { type: '' } }}
        </button>
        <button
          type="button"
          class="btn btn-secondary mt-auto w-100 h-100"
          (click)="updateCheckedElements(); openModal(addItemsToWorkspaceModalTemplate)"
        >
          <i class="icon element-plus"></i>{{ 'LOAD_MODAL.ADD_TO_WORKSPACE' | translate }}
        </button>
        @if (areSelectedItemsDeleted()) {
          <button
            type="button"
            class="btn btn-secondary mt-auto w-100 h-100"
            (click)="updateCheckedElements(); showRestoreItemsDialog()"
          >
            <i class="icon element-restore"></i
            >{{
              'SHARED.RESTORE'
                | translate
                  : {
                      type:
                        `${(this.dataType() | uppercase)}.${(this.dataType() | uppercase)}`
                        | translate
                    }
            }}
          </button>
        } @else {
          <button
            type="button"
            class="btn btn-secondary mt-auto w-100 h-100"
            (click)="updateCheckedElements(); showDeleteItemsDialog()"
          >
            <i class="icon element-delete"></i
            >{{
              areSelectedItemsDeleted()
                ? 'Restore'
                : ('SHARED.DELETE_ITEM'
                  | translate
                    : {
                        type:
                          `${(this.dataType() | uppercase)}.${(this.dataType() | uppercase)}`
                          | translate
                      })
            }}
          </button>
        }
      </div>
    }
  </div>
</div>

<!-- Add to Workspace Modal Template -->
<ng-template #addItemsToWorkspaceModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">{{
      'LOAD_MODAL.ADD_TO_WORKSPACE' | translate
    }}</h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <!--Select -->
    <si-select
      labelledby="multi-select"
      multi
      class="form-control mb-8"
      placeholder="Select an option"
      [options]="workspacesToSaveTrackInOptions()"
      [(ngModel)]="selectedWorkspaceIdsToSaveTrackIn"
    />
    <!-- Submit Button -->
    <button
      type="button"
      class="btn btn-secondary btn-sm"
      (click)="
        closeModal(modalRef);
        onAddItemsToWorkspacesClick();
        this.selectedWorkspaceIdsToSaveTrackIn.set([])
      "
      >{{ 'LOAD_MODAL.ADD_TO_WORKSPACE' | translate }}
    </button>
  </div>
</ng-template>

<!-- Add Tags to Items Modal Template -->
<ng-template #addTagsToItemsModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">{{
      'LOAD_MODAL.ADD_TAGS_TO_ITEMS' | translate
    }}</h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <!--Select -->
    <si-select
      labelledby="multi-select"
      multi
      class="form-control mb-8"
      placeholder="Select an option"
      [options]="tagsToAddToItemsOptions()"
      [(ngModel)]="selectedTagIdsToAddToItems"
    />
    <!-- Submit Button -->
    <button
      type="button"
      class="btn btn-secondary btn-sm"
      (click)="
        closeModal(modalRef);
        onAddTagsToItemsClick();
        this.selectedWorkspaceIdsToSaveTrackIn.set([])
      "
    >
      {{ 'LOAD_MODAL.ADD_TAGS_TO_ITEMS' | translate }}
    </button>
  </div>
</ng-template>

<!-- Remove Tags from Items Modal Template -->
<ng-template #removeTagsFromItemsModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">{{
      'LOAD_MODAL.REMOVE_TAGS_FROM_ITEMS' | translate
    }}</h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <!--Select -->
    <si-select
      labelledby="multi-select"
      multi
      class="form-control mb-8"
      placeholder="Select an option"
      [options]="tagsToRemoveFromItemsOptions()"
      [(ngModel)]="selectedTagIdsToRemoveFromItems"
    />
    <!-- Submit Button -->
    <button
      type="button"
      class="btn btn-secondary btn-sm"
      (click)="
        closeModal(modalRef);
        onRemoveTagsFromItemsClick();
        this.selectedWorkspaceIdsToSaveTrackIn.set([])
      "
    >
      <i class="icon element-minus"></i>{{ 'LOAD_MODAL.REMOVE_TAGS_FROM_ITEMS' | translate }}
    </button>
  </div>
</ng-template>

<!-- Add Tags to Workspaces Modal Template -->
<ng-template #addTagsToWorkspaceModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">{{
      'LOAD_MODAL.CREATE_TAG_IN_WORKSPACE' | translate
    }}</h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <!--Input -->
    <label for="exampleInput" class="form-label">Name</label>
    <input
      type="text"
      class="form-control mb-8"
      id="exampleInput"
      placeholder="New tag"
      [(ngModel)]="tagNameToAddToWorkspace"
    />
    <!-- Submit Button -->
    <button
      type="button"
      class="btn btn-secondary btn-sm"
      (click)="
        closeModal(modalRef);
        onAddTagToWorkspaceClick();
        this.selectedWorkspaceIdsToSaveTrackIn.set([])
      "
    >
      <i class="icon element-plus"></i>{{ 'LOAD_MODAL.CREATE_TAG_IN_WORKSPACE' | translate }}
    </button>
  </div>
</ng-template>

<!-- Delete Tags from Workspaces Modal Template -->
<ng-template #deleteTagsFromWorkspaceModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title" id="sample-modal-title">{{
      'LOAD_MODAL.REMOVE_FROM_WORKSPACE' | translate: { type: 'Tags' }
    }}</h4>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    <!--Select -->
    <si-select
      labelledby="multi-select"
      multi
      class="form-control mb-8"
      placeholder="Select an option"
      [options]="tagsToRemoveFromWorkspaceOptions()"
      [(ngModel)]="selectedTagIdsToDeleteFromWorkspace"
    />
    <!-- Submit Button -->
    <button
      type="button"
      class="btn btn-secondary btn-sm"
      [disabled]="selectedTagIdsToDeleteFromWorkspace().length === 0"
      (click)="
        showDeleteTagsActionDialog(
          {
            type: 'delete-confirm',
            heading:
              selectedTagIdsToDeleteFromWorkspace().length > 1 ? 'Delete tags?' : 'Delete tag?',
            message:
              selectedTagIdsToDeleteFromWorkspace().length > 1
                ? 'The tags will be removed from the workspace and all items'
                : 'The tag will be removed from the workspace and all items'
          },
          modalRef
        )
      "
      >{{ selectedTagIdsToDeleteFromWorkspace().length > 1 ? 'Delete tags' : 'Delete tag' }}
    </button>
  </div>
</ng-template>

<ng-template #tagsContextMenu>
  <si-menu>
    @if (selectedWorkspace(); as workspace) {
      @if (workspace.tags.length > 0) {
        @for (tag of workspace.tags; track $index) {
          <si-menu-item (click)="onTagSelect(tag.name)">{{ tag.name }}</si-menu-item>
        }
        <si-menu-divider />
      }
      <si-menu-item
        icon="element-plus"
        (click)="updateCheckedElements(); openModal(addTagsToWorkspaceModalTemplate)"
        >{{ 'SHARED.CREATE' | translate }}</si-menu-item
      >
      <si-menu-item
        icon="element-delete"
        (click)="updateCheckedElements(); openModal(deleteTagsFromWorkspaceModalTemplate)"
        >{{ 'SHARED.DELETE' | translate }}</si-menu-item
      >
    }
  </si-menu>
</ng-template>
